import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import GateEvents from "./pages/GateEvents";
import { Containers, ContainerDetail } from "./pages/Containers";
import EDIMessages from "./pages/EDIMessages";
import AuditLog from "./pages/AuditLog";
import Stock from "./pages/Stock";
import EdiRecipients from "./pages/EdiRecipients";
import Tariffs from "./pages/Tariffs";
import Invoices from "./pages/Invoices";
import EIRs from "./pages/EIRs";
import Users from "./pages/Users";
import WashStation from "./pages/WashStation";
import Reports from "./pages/Reports";
import LongStayReport from "./pages/LongStayReport";
import Repairs from "./pages/Repairs";
import Partners from "./pages/Partners";
import Rentals from "./pages/Rentals";
import CargoProducts from "./pages/CargoProducts";
import Help from "./pages/Help";
import DocumentIntake from "./pages/DocumentIntake";
import ReleaseOrders from "./pages/ReleaseOrders";
import GateApp from "./pages/GateApp";
import PartnerDuplicates from "./pages/PartnerDuplicates";

function App() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <GoogleOAuthProvider clientId={googleClientId || ""}>
      <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/gate"
            element={
              <ProtectedRoute>
                <GateApp />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="gate-events" element={<GateEvents />} />
            <Route path="eirs" element={<EIRs />} />
            <Route path="wash-station" element={<WashStation />} />
            <Route path="stock" element={<Stock />} />
            <Route path="containers" element={<Containers />} />
            <Route path="containers/:number" element={<ContainerDetail />} />
            <Route path="tariffs" element={<Tariffs />} />
            <Route path="cargo-products" element={<CargoProducts />} />
            <Route path="invoices" element={<Invoices />} />
            <Route path="repairs" element={<Repairs />} />
            <Route path="rentals" element={<Rentals />} />
            <Route path="partners" element={<Partners />} />
            <Route
              path="partners/duplicates"
              element={
                <ProtectedRoute roles={["admin", "general_manager"]}>
                  <PartnerDuplicates />
                </ProtectedRoute>
              }
            />
            <Route path="reports" element={<Reports />} />
            <Route path="reports/long-stay-hlc" element={<LongStayReport />} />
            <Route path="document-intake" element={<DocumentIntake />} />
            <Route path="help" element={<Help />} />
            <Route path="users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
            <Route path="edi" element={<EDIMessages />} />
            <Route path="release-orders" element={<ReleaseOrders />} />
            <Route
              path="edi-recipients"
              element={
                <ProtectedRoute roles={["supervisor", "admin"]}>
                  <EdiRecipients />
                </ProtectedRoute>
              }
            />
            <Route
              path="audit"
              element={
                <ProtectedRoute roles={["supervisor", "admin"]}>
                  <AuditLog />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
